// This file was auto-generated by Fern from our API Definition.
export var McpCredentialBinding;
(function (McpCredentialBinding) {
    McpCredentialBinding.Kind = {
        Header: "header",
        Query: "query",
        Url: "url",
    };
})(McpCredentialBinding || (McpCredentialBinding = {}));
